<template>
	<div>
		<svg
			:width="size"
			:height="size"
			viewBox="0 0 21 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.5 16.8776C14.3329 17.12 15.2138 17.25 16.125 17.25C17.6037 17.25 19.0025 16.9076 20.2464 16.2978C20.2488 16.2405 20.25 16.1829 20.25 16.125C20.25 13.8468 18.4031 12 16.125 12C14.7069 12 13.456 12.7155 12.7136 13.8052M13.5 16.8776V16.875C13.5 15.7621 13.2148 14.7158 12.7136 13.8052M13.5 16.8776C13.5 16.9132 13.4997 16.9488 13.4991 16.9843C11.6374 18.1052 9.45647 18.75 7.125 18.75C4.79353 18.75 2.61264 18.1052 0.75092 16.9843C0.750309 16.948 0.75 16.9115 0.75 16.875C0.75 13.3542 3.60418 10.5 7.125 10.5C9.53292 10.5 11.629 11.835 12.7136 13.8052M10.5 4.125C10.5 5.98896 8.98896 7.5 7.125 7.5C5.26104 7.5 3.75 5.98896 3.75 4.125C3.75 2.26104 5.26104 0.75 7.125 0.75C8.98896 0.75 10.5 2.26104 10.5 4.125ZM18.75 6.375C18.75 7.82475 17.5747 9 16.125 9C14.6753 9 13.5 7.82475 13.5 6.375C13.5 4.92525 14.6753 3.75 16.125 3.75C17.5747 3.75 18.75 4.92525 18.75 6.375Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgForumCommunity',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
